import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .factory('SessionInjectorFactory', SessionInjectorFactory);

    function SessionInjectorFactory(LocalStorageService) {
        return {
            request: function (config) {
                if (
                    config.headers &&
                    config.headers['Authorization'] === 'IM'
                ) {
                    config.headers['Authorization'] = undefined;
                } else if (LocalStorageService.read('common/token')) {
                    config.headers['Authorization'] = LocalStorageService.read(
                        'common/token'
                    );
                }

                return config;
            },
        };
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/session.factory.ts